import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import UserMenu from '../components/userMenu'
import Toast from './sub_components/toast'
import * as depositWithdrawalService from '../services/depositWithdrawalService';
import * as dateUtil from '../util/date.util'
import Currency from './sub_components/currency'
import { CSVLink } from 'react-csv';
import printJS from 'print-js'
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';
import * as _ from 'lodash'
import * as authUtil from "../util/auth.util";
class DepositWithdrawReport extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            orders_data: [],
            total_page: 0,
            action: "",
            csv_json: [],
            pdf_json: [],
            orders_search_data: [],
            from: "",
            to: "",
            showPopup: false,
            records_per_page: 25,
            user_id: "",
            page_no: 1,
            count_records: 0,
            order_id: "",
            market_bets_data: [],
            showToast: false,
            toastMsg: "",
            toastType: "",
            showData: false,
            loader: false,
            isMaintanance: false,
            type:"ALL",
            status: "ALL"
        };
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }
    componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if(!(!!userData && !!userData.sub)){
            authUtil.logout(true);
        }
        this.setState({ user_id: userData.sub })
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ to: curDate, from: weekDate })

    }
    parseToPickerDate(date) {
        let dtArr = date.split("/")
        let dt = dtArr[2] + "-" + (dtArr[0].split("").length === 2 ? dtArr[0] : "0" + dtArr[0]) + "-" + (dtArr[1].split("").length === 2 ? dtArr[1] : "0" + dtArr[1])
        return dt
    }
    parseFilterBody() {
        let body = {
            "from": new Date(this.state.from).toISOString(),
            "to": new Date(this.state.to).toISOString(),
        }
        body = this.clean(body);
        return body
    }
    async submitForm() {
        const self = this;
        let body = this.parseFilterBody()
        this.setState({ loader: true })
        await depositWithdrawalService.getDepositWithdrawalReport(body).then((res) => {
            if (res.isSuccess) {
                const sorteddata = res.items.sort((a, b) => (b["createdAt"] > a["createdAt"]) ? 1 : ((a["createdAt"] > b["createdAt"]) ? -1 : 0))
                self.setState(
                    {
                        orders_data: [],
                        orders_search_data: [],
                        total_page: 0,
                        action: "",
                        records_per_page: res.recordsPerPage,
                        page_no: 1,
                        count_records: res.countRecords,
                        showData: true,
                    }, () => {
                        this.setState({
                            total_page: Math.ceil(sorteddata.length/this.state.records_per_page),
                            page_no: 1,
                            count_records: sorteddata.length,
                            orders_search_data: sorteddata,
                            orders_data: sorteddata,//.splice(0,this.state.records_per_page),
                            loader: false
                        })
                    }
                );
            }
            else {
                this.setState({ showData: true, loader: false, orders_data: [], orders_search_data: [], order_id: [], market_bets_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0 })
            }
        })
    }

    async onDownload() {
        const self = this;
        this.setState({ csv_json: [] }, () => {

            let order = this.state.orders_search_data
            let items = []
            let dictinory = {}
            for (let x of order) {
                dictinory = {}
                dictinory["Date"] = new Date((x["createdAt"]).split(" ")[0] + "T" + (x["createdAt"]).split(" ")[1] + ".000+00:00").toLocaleString("en-IN")

                dictinory["OrderId"] = !!x["orderId"] ? x["orderId"] : x["withdrawId"]
                dictinory["Amount"] = x["amount"]
                dictinory["PaymentMode"] = x["paymentMode"] === 'Bank'? x["paymentMode"] : x["routingInformation"]
                dictinory["Type"] = !!x["orderId"] ? "DEPOSIT" : "WITHDRAW"
                dictinory["Type"] = !!x["orderId"] ? x["orderStatus"] : x["status"]
                dictinory["Description"] = x["status"] === "REJECTED" || x["status"] === "FAILED"? (!!x["message"] ? 'Reason:' + x["message"] : '') : x["status"] === "SUCCESS" ? (!!x["message"] ? 'RefID:' + x["message"] : '') : '';

                items.push(dictinory)
            }

            this.setState({ csv_json: items }, () => {
                setTimeout(function () {
                    self.csvLink.current.link.click();
                }, 500)
            })
        })

    }
    async onPDFDownload() {
        this.setState({ pdf_json: [] }, () => {
            this.setState({ pdf_json: this.state.orders_search_data }, () => {
                setTimeout(function () {
                    printJS({
                        printable: 'printJS-div',
                        type: 'html',
                        targetStyles: ['*']
                    })
                }, 500)
            })
        })
    }
    // async onMarketBets() {
    //     const self = this;
    //     let body = {
    //         "filters": {
    //             "order_id": this.state.order_id,
    //             "user_id": this.state.accounts,
    //             "market_id": ""
    //         },
    //     }
    //     body = this.clean(body);
    //     await casinoReportsService.postMarketBets(body).then((res) => {
    //         if (res.isSuccess) {
    //             self.setState({ market_bets_data: res.items });
    //         } else {
    //             this.setState({ order_id: "", market_bets_data: [] })
    //         }
    //     })
    // }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }
    onAction(e) {
        const value = e.target.name;
        let page_n = 0;
        if (value === "next") {
            page_n = this.state.page_no + 1;
        }
        if (value === "prev") {
            page_n = this.state.page_no - 1;
        }

        this.setState({ action: value, page_no: page_n }, () => { this.submitForm(); });
    }
    onSubmit(e) {
        let diffTime = Math.abs(new Date(this.state.to) - new Date(this.state.from))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > 31) {
            this.showToast("Date range must be 1 month.", "error")
        }
        else {
            this.setState({ action: "", page_no: 1 }, () => { this.submitForm(); });
        }
    }
    resetForm() {
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ showData: false, records_per_page: 25, order_id: [], market_bets_data: [], from: weekDate, to: curDate, orders_data: [], orders_search_data: [], last_id: "", first_id: "", action: "", page_no: 1, count_records: 0, type:"ALL", status: "ALL" })
    }
    onChange(e) {
        const name = e.target.name;
        let value = e.target.value;
        if (name === "records_per_page" || name === "records_display") {
            this.setState({ [name]: value, last_id: "", first_id: "", action: "", page_no: 1, count_records: 0}, () => { this.submitForm() });
        }
        else {
            this.setState({ [name]: value});
        }
    }
    onDateTimeChange(name, e) {
        this.setState({ [name]: e._d })
    }
    onSearch(e) {
        const value = e.target.value;
        if (this.state.orders_search_data) {
            let orders_lst = _.filter(this.state.orders_search_data, function (obj) {
                return JSON.stringify(obj).toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            this.setState({ orders_data: [] }, () => {
                this.setState({ orders_data: orders_lst });
            })
        }
    }
    filterReport(){
        let returnData = this.state.orders_data
        if(this.state.type !== 'ALL'){
            returnData = returnData.filter(n=> (this.state.type === 'DEPOSIT' ? (!!n.orderId) : (!!n.withdrawId)));
        }
        if(this.state.status !== 'ALL'){
            returnData = returnData.filter(n=> (!!n.orderId ? (n.orderStatus === this.state.status) : (n.status === this.state.status)));
        }
        return returnData
    }
    render() {
        let page_no = parseInt(this.state.page_no)
        let count_records = parseInt(this.state.count_records)
        let records_per_page = parseInt(this.state.records_per_page)
        let current_record = 0
        let total_record = 0
        let start_record = 0
        if (count_records > (records_per_page * page_no)) {
            current_record = records_per_page * page_no
            total_record = count_records
            start_record = current_record - (records_per_page - 1)
        } else if (this.state.orders_data.length > 0) {
            current_record = count_records
            total_record = count_records
            start_record = ((page_no - 1) * records_per_page) + 1
        }
        const orders_data = this.filterReport()
        return (
            <div className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) =>this.props.showSweetAlert(options)} MySwal={this.props.MySwal} subscribe={(type, id)=>{this.props.subscribe(type, id)}} subscriptions={this.props.subscriptions} history = {this.props.history} socket={this.props.socket} updateMaintanence={(status)=>{this.updateMaintanence(status)}}/>
                <div className="full-wrap">
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="mar-top100">
                            <div className="sub_path center-box mt-2">
                                <p>Transactions Report</p>
                            </div>
                            <div className="allreport col3">
                                <div className="row mx-0">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.from}
                                                onChange={(e) => this.onDateTimeChange("from", e)}
                                                id="from_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="form-group font-12">
                                            <Datetime
                                                value={this.state.to}
                                                onChange={(e) => this.onDateTimeChange("to", e)}
                                                id="to_datetime"
                                                dateFormat={"DD/MM/YYYY"}
                                                timeFormat={"HH:mm"}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 mt-2">
                                        <div className="btn-group" role="group" aria-label="Basic example" id="divpagecount">
                                            <button className="btn place-bet-btn" onClick={(e) => this.onSubmit(e)}>Go</button>
                                            <button className="btn place-bet-btn ml-1" onClick={(e) => this.resetForm()}>Reset</button>
                                        </div>
                                    </div>
                                </div>
                                {!this.state.showData && !!this.state.loader ? <div className={"ml-2"}>Loading......</div> : null}
                                {!!this.state.showData && <div>
                                    <div className="row text-center mt-2 mx-0 px-1">
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 mt-1 px-2">
                                            <div className="d-flex float-left">
                                                <div className="form-group mb-0 d-inline">
                                                    <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                                </div>
                                                <div className="form-group mb-0 d-inline ml-3">
                                                    <select onChange={(e) => this.onChange(e)} title="Type" className="form-control" name="type" value={this.state.type}>
                                                        <option value="ALL">All</option>
                                                        <option value="DEPOSIT">Deposit</option>
                                                        <option value="WITHDRAW">Withdraw</option>
                                                    </select>
                                                </div>
                                                <div className="form-group mb-0 d-inline ml-3">
                                                    <select onChange={(e) => this.onChange(e)} title="Status" className="form-control" name="status" value={this.state.status}>
                                                        <option value="ALL">All</option>
                                                        <option value="INITIATED">Initiated</option>
                                                        <option value="SUCCESS">Success</option>
                                                        <option value="FAILED">Failed</option>
                                                        {this.state.type !== "WITHDRAW" && <option value="PROCESS">Process</option>}
                                                        {this.state.type !== "WITHDRAW" && <option value="CANCELLED">Cancelled</option>}
                                                        {this.state.type !== "DEPOSIT" && <option value="APPROVED">Approved</option>}
                                                        {this.state.type !== "DEPOSIT" && <option value="REJECTED">Rejected</option>}
                                                    </select>
                                                </div>
                                                <CSVLink
                                                    data={this.state.csv_json}
                                                    filename={"BetHistory-Report.csv"}
                                                    asyncOnClick={true}
                                                    className="d-none"
                                                    ref={this.csvLink}>
                                                </CSVLink>
                                                <button className="btn btn-sm d-inline csv-icon p-0" title="Export CSV" onClick={(e) => this.onDownload(e)} disabled={this.state.orders_data.length > 0 ? false : true}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/csv-icon.svg"}></img></button>
                                                <div style={{ display: "none" }}>
                                                    <div id="printJS-div" className="w-100" style={{ width: '100%' }}>
                                                        <table id="exportall" className="table font-12 table-bordered table-sm w-100" style={{ border: "1px solid #000", color: "#212529", fontSize: '12px', width: '100%' }}>
                                                            <thead>
                                                                <tr className="bg-dark text-white">
                                                                    <th className="pthead">Date</th>
                                                                    <th className="pthead">OrderID</th>
                                                                    <th className="pthead">Amount</th>
                                                                    <th className="pthead">PaymentMode</th>
                                                                    <th className="pthead">PaymentDetails</th>
                                                                    <th className="pthead">Type</th>
                                                                    <th className="pthead">Status</th>
                                                                    <th className="pthead">Description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.pdf_json.length > 0 ? this.state.pdf_json.map((order, i) => {
                                                                    const dt = new Date((order.createdAt).split(" ")[0] + "T" + (order.createdAt).split(" ")[1] + ".000+00:00").toLocaleString("en-IN")
                                                                    const ordertype = !!order.orderId ? "DEPOSIT" : "WITHDRAW";
                                                                    const orderclass = ordertype === "DEPOSIT" ? (order.orderStatus === "SUCCESS" ? "font-weight-bold text-success" : order.orderStatus === "CANCELLED" || order.orderStatus === "FAILED" ? "font-weight-bold text-danger" : order.orderStatus === "INITIATED" || order.orderStatus === "PROCESS" ? "font-weight-bold text-warning" : "") : (order.status === "SUCCESS" ? "font-weight-bold text-success" : order.status === "REJECTED" || order.status === "FAILED" ? "font-weight-bold text-danger" : order.status === "INITIATED" || order.status === "APPROVED" || order.status === "PENDING" ? "font-weight-bold text-warning" : "");
                                                                    return (
                                                                        <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : "#FFFFFF"}>
                                                                            <td className="">{dt}</td>
                                                                            <td className="">{ordertype === "DEPOSIT" ? order.orderId : order.withdrawId}</td>
                                                                            
                                                                            <td className="font-weight-bold text-right">{order.amount}</td>
                                                                            <td className="">{!!order.paymentMode ? order.paymentMode : ''}</td>
                                                                            <td className="">{ordertype !== "DEPOSIT" ? (`${order.paymentMode === 'Bank' ? order.paymentMode + '-' + order.routingInformation : order.routingInformation}/${order.accountName}/${order.accountNumber}`) : ''}</td>
                                                                            <td className="">{ordertype}</td>
                                                                            <td className={orderclass}>{ordertype === "DEPOSIT" ? order.orderStatus : order.status}</td>
                                                                            <td>
                                                                            {
                                                                                (!!order.message && (ordertype === "DEPOSIT" ? (order.orderStatus === "REJECTED" || order.orderStatus === "FAILED" || order.orderStatus === "SUCCESS") : (order.status === "REJECTED" || order.status === "FAILED" || order.status === "SUCCESS" || order.status === "PENDING")) &&
                                                                                <span>{order.message}</span>)
                                                                            }
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                }) : <tr style={{ display: "none" }}>
                                                                    <td colSpan={17} className="text-center"><h5 className="text-danger font-weight-bold m-0">No Bet History</h5></td>
                                                                </tr>}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <button className="btn btn-sm pdf-icon d-inline p-0" title="Export PDF" onClick={(e) => this.onPDFDownload(e)} disabled={this.state.orders_data.length > 0 ? false : true}>
                                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/images/pdf-icon.svg"}></img>
                                                </button>
                                            </div>
                                        </div>
                                        {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <span className="d-inline search-report ml-2">entries</span>
                                            <div className="form-group font-12 float-right mb-0">
                                                <select onChange={(e) => { this.onChange(e) }} className="form-control" name="records_per_page" value={this.state.records_per_page}>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                            </div>
                                            <span className="d-inline search-report">Show</span>
                                        </div> */}
                                    </div>
                                    <div className="dt-responsive table-responsive account-statment p-2">
                                        <table id="basic-btn" className="table table-bordered table-sm mb-1 addpadding nowrap">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th className="pthead">Date</th>
                                                    <th className="pthead">OrderID</th>
                                                    <th className="pthead">Amount</th>
                                                    <th className="pthead">PaymentMode</th>
                                                    <th className="pthead">PaymentDetails</th>
                                                    <th className="pthead">Type</th>
                                                    <th className="pthead">Status</th>
                                                    <th className="pthead">Description</th>
                                                </tr>
                                            </thead>
                                            <tbody id="tblAccountStatement">
                                                {!!this.state.loader ?
                                                    <tr>
                                                        <td colSpan={17} className="text-center py-5">
                                                            <h5 className="text-dark font-weight-bold m-0"> Loading...... </h5>
                                                        </td>
                                                    </tr> :
                                                    orders_data.length > 0 ? orders_data.map((order, i) => {
                                                        const dt = new Date((order.createdAt).split(" ")[0] + "T" + (order.createdAt).split(" ")[1] + ".000+00:00").toLocaleString("en-IN")
                                                        const ordertype = !!order.orderId ? "DEPOSIT" : "WITHDRAW";
                                                        const orderclass = ordertype === "DEPOSIT" ? (order.orderStatus === "SUCCESS" ? "font-weight-bold text-success" : order.orderStatus === "CANCELLED" || order.orderStatus === "FAILED" ? "font-weight-bold text-danger" : order.orderStatus === "INITIATED" || order.orderStatus === "PROCESS" ? "font-weight-bold text-warning" : "") : (order.status === "SUCCESS" ? "font-weight-bold text-success" : order.status === "REJECTED" || order.status === "FAILED" ? "font-weight-bold text-danger" : order.status === "INITIATED" || order.status === "APPROVED" || order.status === "PENDING" ? "font-weight-bold text-warning" : "");
                                                        return (
                                                            <tr key={i} bgcolor={order.side === 0 ? "#72BBEF" : order.side === 1 ? "#FAA9BA" : ""}>
                                                                <td className="">{dt}</td>
                                                                <td className="">{ordertype === "DEPOSIT" ? order.orderId : order.withdrawId}</td>
                                                                
                                                                <td className="font-weight-bold text-right">{order.amount}</td>
                                                                <td className="">{!!order.paymentMode ? order.paymentMode : ''}</td>
                                                                <td className="">{ordertype !== "DEPOSIT" ? (`${order.paymentMode === 'Bank' ? order.paymentMode + '-' + order.routingInformation : order.routingInformation}/${order.accountName}/${order.accountNumber}`) : ''}</td>
                                                                <td className="">{ordertype}</td>
                                                                <td className={orderclass}>{ordertype === "DEPOSIT" ? order.orderStatus : order.status}</td>
                                                                <td>
                                                                {
                                                                    (!!order.message && (ordertype === "DEPOSIT" ? (order.orderStatus === "REJECTED" || order.orderStatus === "FAILED" || order.orderStatus === "SUCCESS") : (order.status === "REJECTED" || order.status === "FAILED" || order.status === "SUCCESS" || order.status === "PENDING")) &&
                                                                    <span>{order.message}</span>)
                                                                }
                                                                </td>
                                                            </tr>
                                                        );
                                                    }) : <tr>
                                                        <td colSpan={17} className="text-center py-5"><h5 className="text-danger font-weight-bold m-0">No Transactions</h5></td>
                                                    </tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div className="row mx-0 px-1 py-3">
                                        <div className="col-12 col-sm-12 col-md-6"><span className="frleft">Showing {start_record} - {current_record} of {total_record} entries</span></div>
                                        <div className="col-12 col-sm-12 col-md-6">
                                            <div className="btn-group float-right" role="group" aria-label="Basic example" id="divpagecount">
                                                <button type="button" className="btn btn-blue" id="PrevPage" name="prev" onClick={(e) => this.onAction(e)} disabled={this.state.first_id === "" ? true : false}>Prev</button>
                                                <button className="btn btn-blue" disabled>
                                                    {
                                                        this.state.page_no
                                                    }
                                                </button>
                                                <button type="button" className="btn btn-blue" id="NextPage" name="next" onClick={(e) => this.onAction(e)} disabled={this.state.last_id === "" ? true : false}>Next</button>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>}
                            </div>
                        </div>
                    </div>
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(DepositWithdrawReport);